import { render, staticRenderFns } from "./ServicesGroupList.vue?vue&type=template&id=02df1eb4"
import script from "./ServicesGroupList.vue?vue&type=script&lang=js"
export * from "./ServicesGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports